// Route definitions only; the schemas they refer to stay out of the web bundle.
import type { z } from 'zod';
import { defineRoute } from './route.ts';
import type {
  createHouseholdBody,
  householdSchema,
  householdsResponse,
  mergeHouseholdBody,
  placeBody,
  renameHouseholdBody,
} from './households.ts';

type Ok = z.ZodObject<{ ok: z.ZodLiteral<true> }>;
type Changed = z.ZodObject<{ changed: z.ZodNumber }>;

export const listHouseholds = defineRoute<{ response: typeof householdsResponse }>()({
  method: 'GET',
  path: '/api/households',
});
export const createHousehold = defineRoute<{
  body: typeof createHouseholdBody;
  response: typeof householdSchema;
}>()({ method: 'POST', path: '/api/households', status: 201 });
export const renameHousehold = defineRoute<{
  body: typeof renameHouseholdBody;
  response: typeof householdSchema;
}>()({ method: 'PATCH', path: '/api/households/:id' });
export const mergeHousehold = defineRoute<{
  body: typeof mergeHouseholdBody;
  response: typeof householdSchema;
}>()({ method: 'POST', path: '/api/households/:id/merge' });
export const deleteHousehold = defineRoute<{ response: Ok }>()({
  method: 'DELETE',
  path: '/api/households/:id',
});
export const setPlace = defineRoute<{ body: typeof placeBody; response: Changed }>()({
  method: 'POST',
  path: '/api/copies/place',
});
